import { render, staticRenderFns } from "./TestCorrectionDemo.vue?vue&type=template&id=b1b57a58&scoped=true"
import script from "./TestCorrectionDemo.vue?vue&type=script&lang=js"
export * from "./TestCorrectionDemo.vue?vue&type=script&lang=js"
import style0 from "./TestCorrectionDemo.vue?vue&type=style&index=0&id=b1b57a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b57a58",
  null
  
)

export default component.exports